import { Component, OnInit,HostListener, Injector, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Tranche } from 'src/app/model/tranche.model';
import { LimitesFundo } from 'src/app/model/limite-agente-financeiro.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { LimiteService } from 'src/app/shared/services/limite.service';
import { LimiteAportado } from 'src/app/model/limite-aportado.model';
import { LimiteAporteService } from 'src/app/shared/services/limite-aporte.service';
import { BaseEntityComponent, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ExportService } from 'src/app/features/habilitacao/export.service';
import { JanelaRenunciaResponseDto, Renuncia, TIPO_JANELA_VALIDACAO } from 'src/app/model/renuncia.model';
import { RenunciaService } from '../../renuncia.service';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { JanelaRenuncia } from 'src/app/model/janela-solicitacao-renuncia.model';
import { JanelaSolicitacaoRenunciaService } from '../../janela-solicitacao-renuncia.service';
import { MensagemService } from '../../../mensagem.service';



@Component({
    selector: 'app-listagem-janela',
    templateUrl: 'listagem-janela.component.html',
    styleUrls: ['./listagem-janela.component.scss'],
    standalone: false
})
export class ListagemJanela extends BaseEntityComponent<JanelaRenuncia> implements OnInit {

    public formJanelaRenuncia: UntypedFormGroup;
    public janelas: JanelaRenuncia[];
    public janelaEdicao: JanelaRenuncia;
    public estaEditando: boolean;
    private idExcluir: number;
    private agenteEnvio: boolean;

    @ViewChild('msgTemplateExcluir')
    msgTemplateExcluir: TemplateRef<any>;
    @ViewChild('botoesPersonalizadosExcluir')
    botoesPersonalizadosExcluir: TemplateRef<any>;

    constructor(protected injector: Injector,
        private janelaSolicitacaoRenunciaService: JanelaSolicitacaoRenunciaService,
        private mensagemService: MensagemService,
        private bnModalService: BnModalMessageService,
        private permissaoService: PermissaoService,) {
        super(janelaSolicitacaoRenunciaService);
    }

    public ngOnInit() {
        this.criarFormJanelaRenuncia();
        this.estaEditando = false;

        const state = history.state;

        if (state?.tipoJanela) {
            this.janelaSolicitacaoRenunciaService.obterJanelasPorTipo(state.tipoJanela).subscribe(janelas => {
                this.janelas = janelas;
            }); 

            history.replaceState({}, document.title);
        } else {
            this.janelaSolicitacaoRenunciaService.findAll().subscribe(janelas => {
                this.janelas = janelas;
            }); 

            history.replaceState({}, document.title);
        }
        
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.agenteEnvio = resp && resp[ROLE_GESTOR_ENVIO];
        });
    }

    criarFormJanelaRenuncia() {
        this.formJanelaRenuncia = this.formBuilder.group({
            dataInicioVigencia: [null, Validators.required],
            dataFimVigencia: [null, Validators.required],
        });
    }

    voltar() {
        this.router.navigate(['/renuncia/tarefas']);
    }

    podeEditar(item: JanelaRenuncia) {
        return this.agenteEnvio && !item.apurado;
    }

    podeExcluir(item: JanelaRenuncia) {
        return this.agenteEnvio && moment().isBefore(item.dataInicioVigencia);
    }

    iniciarEdicao(item: JanelaRenuncia) {
        this.formJanelaRenuncia.reset();
        this.estaEditando = true;
        this.janelaEdicao = item;
        this.formJanelaRenuncia.get('dataInicioVigencia').enable();
        this.formJanelaRenuncia.get('dataFimVigencia').enable();
        this.formJanelaRenuncia.get('dataInicioVigencia').setValue(moment(item.dataInicioVigencia));

        if (moment().isAfter(item.dataInicioVigencia)) {
            this.formJanelaRenuncia.get('dataInicioVigencia').disable();
        }

        this.formJanelaRenuncia.get('dataFimVigencia').setValue(moment(item.dataFimVigencia));
    }

    salvar() {
        this.janelaEdicao.dataInicioVigencia = moment(this.formJanelaRenuncia.get('dataInicioVigencia').value).toDate();
        this.janelaEdicao.dataFimVigencia = moment(this.formJanelaRenuncia.get('dataFimVigencia').value).toDate();

        try {
            this.janelaSolicitacaoRenunciaService.salvar(this.janelaEdicao).subscribe(janela => {
                this.mensagemService.adicionarMensagemSucesso('Janela de vigência para solicitação de renúncia editada com sucesso.');
                this.voltar();
            });
        } catch (error) {
            console.error('Erro ao salvar janela de vigência para solicitação de renúncia.', error);
            this.mensagemService.adicionarMensagemErro('Erro ao salvar janela de vigência para solicitação de renúncia.');
        }

        this.formJanelaRenuncia.reset();
        this.janelaEdicao = null;
        this.estaEditando = false;
    }

    prepararExcluir(item: JanelaRenuncia) {
        this.idExcluir = item.id;

        this.bnModalService.abrir(
            'Confirmação',
            'Esta ação irá EXCLUIR a janela de renúncia selecionada.',
            'lg',
            this.msgTemplateExcluir,
            this.botoesPersonalizadosExcluir
          );        
    }

    cancelarEdicao() {
        this.formJanelaRenuncia.reset();
        this.janelaEdicao = null;
        this.estaEditando = false;

        this.voltar();
    }

    excluir() {
        this.janelaSolicitacaoRenunciaService.excluir(this.idExcluir).subscribe(janelas => {
            this.mensagemService.adicionarMensagemSucesso('Janela de solicitação de renúncia foi excluída com sucesso.');
            this.dismissModal();
            this.voltar();
        });
    }

    dismissModal() {
        this.bnModalService.dismiss();
    }

    public descricaoTipoJanela = Object.fromEntries(
        TIPO_JANELA_VALIDACAO.filter(x => x.value).map(x => [x.value, x.label])
    );
}
